<template>
  <div><el-overlay-loading loading /></div>
</template>

<script>
export default {
  data() {
    return {}
  },

  created() {
    window.close()
  },
}
</script>

<style></style>
